import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://ncdqjyxufrvmdrpmctxo.supabase.co'
const SUPABASE_PUBLISHABLE_KEY = 'sb_publishable_mNTPPnOWkfgadZoO1NVcSw_OSs1RYFi'

export const supabaseClient = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY)

export const storage = {
  async get(key: string) {
    const { data, error } = await supabaseClient
      .from('app_state')
      .select('value')
      .eq('key', key)
      .maybeSingle()

    if (error) throw error
    return data ? { value: JSON.stringify(data.value) } : null
  },

  async set(key: string, value: string) {
    let parsed: unknown
    try {
      parsed = JSON.parse(value)
    } catch {
      parsed = value
    }

    const { error } = await supabaseClient
      .from('app_state')
      .upsert(
        { key, value: parsed, updated_at: new Date().toISOString() },
        { onConflict: 'key' },
      )

    if (error) throw error
    return { ok: true }
  },
}
